const messages = {
  title: "Om BS Plus",
  description: "About page description",
};

export default {
  messages,
};
